/* ===========================================================================
 * 08 Left - Customize  (custom-changes popup)
 * ---------------------------------------------------------------------------
 * A "Customize" button opens a popup to request a color / text / orientation /
 * version (White Line / Raw Metal) change on a print. The customer's
 * instructions are captured in the popup and
 * attached to the order as Shopify line-item PROPERTIES on the change product,
 * so the merchant sees exactly what to proof - no email back-and-forth.
 *
 * Pure theme JS, no backend. Members get color/text free via Conjured's
 * checkout discount (untouched here). Color change is hidden on Limited
 * Edition / Heavy / Limited Metal pieces.
 *
 * Trigger: any element with class "ol-customize-btn". Optional data attributes
 * carry product context (added by the Liquid block):
 *   data-product-title, data-product-tags, data-product-handle
 *
 * Pure ASCII (special chars as HTML entities) so a paste can't corrupt it.
 * ======================================================================== */
(function () {
  "use strict";
  if (window.__olCustomizeLoaded) return;
  window.__olCustomizeLoaded = true;

  var VERSION = "2026-10-06.1";
  console.log("%c[08L customize] " + VERSION, "color:#0a0a0a;background:#f9cb0c;padding:2px 6px;border-radius:3px;font-weight:700");

  var INK = "#0a0a0a", YELLOW = "#f9cb0c", RED = "#c42126";
  var FONT = '"proxima-nova","Proxima Nova",-apple-system,BlinkMacSystemFont,"Helvetica Neue",Helvetica,Arial,sans-serif';

  // The change products (variant ids + prices in cents).
  var CHANGES = {
    color:  { vid: 20253450600536, price: 499, label: "Color change", excludeLimited: true },
    text:   { vid: 20253460299864, price: 249, label: "Text + design change" },
    orient: { vid: 20253453582424, price: 0,   label: "Diagram orientation" },
    version:{ vid: 55007941394754, price: 0,   label: "Version change" }
  };

  // "Wood, Canvas or Big Metal" = the generic BONUS product. Metal & Heavy Matte
  // are already sold on the product page up to 24 x 36, so Metal is offered here
  // ONLY in the sizes the product page does not sell (BONUS.only) - the BONUS
  // product's smaller metals carry different prices (Ryan, 2026-10-06).
  // Variants (and prices) are fetched live so they always stay current.
  var BONUS = { handle: "airport-layouts-bonus-designs-and-media", materials: ["Wood", "Canvas", "Metal"],
                only: { Metal: ["40 x 60"] }, label: { Metal: "Big Metal" } };
  var bonusCache = null;
  function loadBonus() {
    if (bonusCache) return Promise.resolve(bonusCache);
    return fetch("/products/" + BONUS.handle + ".js").then(function (r) { return r.json(); }).then(function (p) {
      bonusCache = (p.variants || []).map(function (v) {
        return { id: v.id, mat: v.options[0], size: v.options[1], design: v.options[2], price: v.price, avail: v.available };
      }).filter(function (v) {
        return BONUS.materials.indexOf(v.mat) >= 0 && v.avail
          && (!BONUS.only[v.mat] || BONUS.only[v.mat].indexOf(v.size) >= 0);
      });
      return bonusCache;
    });
  }

  var state = { open: false, cssDone: false };

  function money(c) { return c === 0 ? "Free" : "$" + (c / 100).toFixed(2).replace(/\.00$/, ""); }
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  function isLimited(ctx) {
    return /limited|heav|no-customize/i.test((ctx.tags || "") + " " + (ctx.title || ""));
  }
  function isMember(ctx) { return ctx.member === "1" || ctx.member === "true"; }
  // Members (annual-first / lifetime-first) get color + text free via Conjured.
  function priceLabel(key, ctx) {
    if (key === "material") return "from $119";
    var cfg = CHANGES[key];
    if (cfg.price === 0) return "Free";
    if (isMember(ctx) && (key === "color" || key === "text")) return "Free";
    return money(cfg.price);
  }
  var PERKS_URL = "https://08left.com/pages/08l-first-class-perks";
  // Members see this; non-members get a nudge linking to the perks page.
  function memberNote(ctx) {
    if (isMember(ctx)) return "Free with your membership &mdash; applied at checkout.";
    return 'Color &amp; text changes are free for <a href="' + PERKS_URL + '" target="_blank" rel="noopener" style="color:inherit;font-weight:700;text-decoration:underline">members</a>.';
  }

  // ---- styles ------------------------------------------------------------
  /* EVERY <button> IN HERE NEEDS AN EXPLICIT color. `font:inherit` does not
     carry colour, and a button with none declared falls back to the UA default,
     which iOS paints BLUE - so .olc-type and .olc-back read as links on a phone
     and as body text on desktop (Ryan 2026-08-21, same bug as the trigger button
     in 08l-product.liquid). Labels like .olc-radio inherit fine; buttons do not.
     Hovers are scoped to (hover:hover) because a touch device has no hover-OFF
     and the highlight stuck after the first tap. */
  function injectCSS() {
    if (state.cssDone) return; state.cssDone = true;
    var c = ""
      + ".olc-overlay{position:fixed;inset:0;background:rgba(10,10,10,.55);display:flex;align-items:center;justify-content:center;z-index:999999;padding:18px;font-family:" + FONT + ";-webkit-font-smoothing:antialiased;opacity:0;transition:opacity .18s;overflow-y:auto}"
      + ".olc-overlay.in{opacity:1}"
      + ".olc-modal{background:#fff;color:" + INK + ";width:100%;max-width:560px;border:1.5px solid " + INK + ";border-radius:12px;padding:30px 30px 26px;position:relative;transform:translateY(8px);transition:transform .18s;box-sizing:border-box;margin:auto}"
      + ".olc-overlay.in .olc-modal{transform:none}"
      + ".olc-modal *{box-sizing:border-box}"
      + ".olc-close{position:absolute;top:10px;right:13px;background:none;border:0;font-size:27px;line-height:1;cursor:pointer;color:" + INK + ";opacity:.5}"
      + ".olc-close:hover{opacity:1}"
      + ".olc-eyebrow{font-size:11px;letter-spacing:.16em;text-transform:uppercase;font-weight:700;opacity:.55;margin-bottom:6px}"
      + ".olc-h{font-size:25px;font-weight:800;letter-spacing:-.4px;margin:0 0 4px;line-height:1.12}"
      + ".olc-for{font-size:13px;opacity:.6;margin:0 0 20px}"
      + ".olc-forart{display:flex;align-items:center;gap:14px;margin:0 0 20px;padding:10px;border:1px solid rgba(10,10,10,.12);border-radius:10px}"
      + ".olc-forart__img{width:74px;height:74px;object-fit:contain;flex:none;background:#f4f4f2;border-radius:6px}"
      + ".olc-forart__t{min-width:0;font-size:14px;line-height:1.35}"
      + ".olc-forart__lbl{display:block;font-size:10.5px;letter-spacing:.14em;text-transform:uppercase;opacity:.5;margin-bottom:3px}"
      + ".olc-types{display:flex;flex-direction:column;gap:10px;margin-bottom:6px}"
      + ".olc-type{display:flex;align-items:center;justify-content:space-between;gap:14px;text-align:left;font:inherit;color:" + INK + ";background:#fff;border:1.5px solid " + INK + ";border-radius:8px;padding:16px 20px;cursor:pointer;transition:background .12s;-webkit-tap-highlight-color:transparent}"
      + "@media (hover:hover){.olc-type:hover{background:" + YELLOW + "}.olc-back:hover{opacity:1}.olc-radio:hover{border-color:" + INK + "}}"
      + ".olc-type .tw{display:flex;flex-direction:column;gap:3px;text-align:left}"
      + ".olc-type .t{display:block;font-size:15px;font-weight:700;line-height:1.2}"
      + ".olc-type .d{display:block;font-size:12.5px;opacity:.65;line-height:1.35}"
      + ".olc-type .p{font-size:14px;font-weight:800;white-space:nowrap}"
      + ".olc-back{font:inherit;font-size:12px;color:" + INK + ";background:none;border:0;cursor:pointer;text-decoration:underline;opacity:.6;padding:0;margin-bottom:14px;-webkit-tap-highlight-color:transparent}"
      + ".olc-field{margin-bottom:16px}"
      + ".olc-field label{display:block;font-size:12px;letter-spacing:.04em;font-weight:700;margin-bottom:6px}"
      + ".olc-field .hint{font-size:12.5px;opacity:.6;margin:0 0 8px;line-height:1.4}"
      + ".olc-field input,.olc-field textarea{width:100%;font:inherit;font-size:14px;padding:11px 13px;border:1.5px solid " + INK + ";background:#fff;color:" + INK + ";border-radius:7px}"
      + ".olc-field textarea{min-height:90px;resize:vertical}"
      + ".olc-radios{display:flex;gap:8px;flex-wrap:wrap;align-items:stretch}"
      /* flex:1 + min-width:160px made every option GROW to fill its row, so two
         short labels like Wood and Canvas each took half the modal and read as
         blown out. Size them to their content instead; padding still gives a
         ~40px tap target, and flex-wrap handles narrow screens. */
      /* MATCHED TO THE PRODUCT PAGE (.olp__pill in 08l-product.liquid), value for
         value: 1.5px rgba(10,10,10,.16) border, 8px radius, 10px/15px padding,
         13.5px/600 type. The popup had a heavier black border and, unlike the
         site, showed the native radio dot - so the same choice looked like two
         different controls depending which one you were looking at. */
      + ".olc-radio{flex:0 0 auto;position:relative;border:1.5px solid rgba(10,10,10,.16);border-radius:8px;padding:10px 15px;cursor:pointer;font-size:13.5px;font-weight:600;white-space:nowrap;line-height:1.15;transition:border-color .14s,box-shadow .14s,background .14s}"
      + ".olc-radio.sel{border-color:" + YELLOW + ";box-shadow:inset 0 0 0 1.5px " + YELLOW + ";background:rgba(249,203,12,.10)}"
      + ".olc-radio input{position:absolute;opacity:0;pointer-events:none}"
      /* The site's Add to cart is YELLOW on near-black type. This was black on
         white and only turned yellow on hover, so the popup's primary action
         did not look like the primary action anywhere else on the store. */
      + ".olc-add{width:100%;font:inherit;font-size:13px;letter-spacing:.11em;text-transform:uppercase;font-weight:700;padding:17px;border:0;border-radius:9px;background:" + YELLOW + ";color:#12120f;cursor:pointer;transition:transform .12s,background .14s;margin-top:4px}"
      + ".olc-add:hover{background:#e0b400;transform:translateY(-1px)}"
      + ".olc-add[disabled]{opacity:.45;cursor:default;transform:none;background:#d8d6cd;color:#5a5a54}"
      + ".olc-note{font-size:12px;opacity:.6;text-align:center;margin-top:10px}"
      + ".olc-msg{font-size:13px;margin-top:10px;min-height:1px;color:" + RED + "}"
      + ".olc-done{text-align:center;padding:12px 0 4px}"
      + ".olc-done .ck{display:inline-flex;align-items:center;justify-content:center;width:48px;height:48px;border-radius:50%;background:" + YELLOW + ";font-size:25px;font-weight:800;margin-bottom:12px}"
      + ".olc-done h4{margin:0 0 6px;font-size:18px;font-weight:800}"
      + ".olc-done p{margin:0;font-size:13.5px;opacity:.75;line-height:1.5}";
    var s = document.createElement("style"); s.id = "olc-style"; s.textContent = c;
    document.head.appendChild(s);
  }

  // ---- cart refresh (Horizon: dispatch cart:update with rendered sections) -
  function cartSectionIds() {
    var ids = {};
    document.querySelectorAll("cart-items-component, cart-drawer-component, cart-icon").forEach(function (el) {
      var sid = el.getAttribute("data-section-id");
      if (!sid) { var h = el.closest("[data-section-id]"); sid = h && h.getAttribute("data-section-id"); }
      if (sid) ids[sid] = 1;
    });
    return Object.keys(ids);
  }
  /* action: "add" lets Horizon's drawer auto-open, "update" only repaints.
     2026-10-01: "Auto-open cart drawer" is now ON. The drawer is a top-layer
     <dialog>, so opening it at add time covered this popup's own "Added to
     your cart" confirmation. Adds now repaint with "update", and the popup's
     close() opens the drawer once the confirmation has had its moment. */
  function refreshCart(addRes, action) {
    fetch("/cart.js").then(function (r) { return r.json(); }).then(function (cart) {
      var sections = (addRes && addRes.sections) || {};
      /* HORIZON 4.1.3 RENAMED THE CART EVENT.
         4.1.3 listens for "shopify:cart:lines-update" and reads
         event.promise -> {cart:{totalQuantity}, detail:{itemCount, sections}},
         with event.action === "add" telling the drawer to open. The legacy
         "cart:update" below is silently ignored, so the item added server-side
         and NOTHING repainted - it only appeared once the next add-to-cart
         fired the correct event. Ryan, 2026-08-12: "it doesn't add to the cart
         until another product is added, then it shows up."
         Identical fix to frame-upsell.js (2026-08-06); this file was missed.
         Legacy events kept below: harmless, and they keep this working if it is
         ever pasted onto the old 1.0.0 theme. */
      try {
        var ev413 = new Event("shopify:cart:lines-update", { bubbles: true });
        ev413.action = action || "add";
        ev413.promise = Promise.resolve({
          cart: { totalQuantity: cart.item_count },
          detail: { itemCount: cart.item_count, source: "customize", sections: sections }
        });
        document.dispatchEvent(ev413);
      } catch (e) {}
      try {
        document.dispatchEvent(new CustomEvent("cart:update", { bubbles: true,
          detail: { resource: {}, sourceId: "customize", data: { itemCount: cart.item_count, source: "customize", sections: sections } } }));
      } catch (e) {}
      ["cart:refresh", "cart:updated", "cart:change"].forEach(function (n) {
        try { document.documentElement.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: { cart: cart } })); } catch (e) {}
      });
    }).catch(function () {});
  }

  /* Fresh sections, then the theme's own event with action "add": the drawer
     re-renders and opens (only if auto-open is on and the cart is not empty). */
  function openCartDrawer() {
    var ids = cartSectionIds();
    var secs = ids.length
      ? fetch("/?sections=" + encodeURIComponent(ids.join(","))).then(function (r) { return r.ok ? r.json() : {}; }).catch(function () { return {}; })
      : Promise.resolve({});
    Promise.all([fetch("/cart.js").then(function (r) { return r.json(); }), secs]).then(function (out) {
      try {
        var ev = new Event("shopify:cart:lines-update", { bubbles: true });
        ev.action = "add";
        ev.promise = Promise.resolve({ cart: { totalQuantity: out[0].item_count },
          detail: { itemCount: out[0].item_count, source: "customize", sections: out[1] } });
        document.dispatchEvent(ev);
      } catch (e) {}
    }).catch(function () {});
  }

  function addChange(vid, properties) {
    var body = { items: [{ id: vid, quantity: 1, properties: properties }], sections: cartSectionIds().join(","), sections_url: location.pathname };
    return fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify(body) })
      .then(function (r) {
        if (r.ok) return r.json();
        /* DO NOT SWALLOW THE SERVER'S REASON. This used to throw a bare
           "add 422" and every caller printed "Something went wrong". Shopify
           was returning {"description":"Cannot find variant"} on EVERY White
           Line / Raw Metal request from 2026-07-20, when the Version Change
           product was recreated with a new variant id and this file was not
           repointed. A month of failures, invisible, because the one sentence
           that explained it was discarded here. */
        return r.json().catch(function () { return null; }).then(function (body) {
          var err = new Error("add " + r.status);
          err.shopifyMsg = body && (body.description || body.message ||
            (typeof body.errors === "string" ? body.errors : ""));
          throw err;
        });
      });
  }

  // ---- popup -------------------------------------------------------------
  function openPopup(ctx, view) {
    if (state.open) return; state.open = true;
    injectCSS();
    var ov = document.createElement("div");
    ov.className = "olc-overlay";
    document.body.appendChild(ov);
    requestAnimationFrame(function () { ov.classList.add("in"); });

    var closed = false;
    function close() {
      if (closed) return; closed = true;
      ov.classList.remove("in");
      setTimeout(function () {
        ov.remove(); state.open = false; document.removeEventListener("keydown", onKey);
        if (ov.__added) openCartDrawer();   // something went in: show the cart + Checkout
      }, 180);
    }
    function onKey(e) { if (e.key === "Escape") close(); }
    document.addEventListener("keydown", onKey);
    ov.addEventListener("click", function (e) { if (e.target === ov) close(); });

    if (view === "material") renderMaterial(ov, ctx, close);
    else renderChooser(ov, ctx, close);
  }

  function shell(inner) {
    return '<div class="olc-modal"><button type="button" class="olc-close" aria-label="Close">&times;</button>' + inner + '</div>';
  }
  /* SHOW THE ARTWORK THEY CAME FROM.
     This popup used to be a bare "For: TITLE" line over two radio buttons, so
     you picked wood vs canvas with nothing on screen to look at, and the cart
     then read "BONUS DESIGNS/MEDIA OPTIONS" because that is the SKU this flow
     actually adds. Putting the customer's own artwork at the top makes both
     halves obvious: what is being made, and that it is THEIR piece.
     Falls back to the plain text line when no image was passed (older buttons,
     the standalone /pages/custom-changes entry point). */
  function forLine(ctx) {
    if (!ctx.title) return "";
    var t = '<strong>' + esc(ctx.title) + "</strong>";
    if (!ctx.image) return '<p class="olc-for">For: ' + t + "</p>";
    return '<div class="olc-forart">'
      + '<img class="olc-forart__img" src="' + esc(ctx.image) + '" alt="' + esc(ctx.title) + '" loading="lazy">'
      + '<div class="olc-forart__t"><span class="olc-forart__lbl">Your artwork</span>' + t + "</div>"
      + "</div>";
  }

  function renderChooser(ov, ctx, close) {
    // No custom changes at all on Limited Edition / Heavy pieces.
    if (isLimited(ctx)) {
      ov.innerHTML = shell(
        '<div class="olc-eyebrow">Make it yours</div>'
        + '<h3 class="olc-h">Customize this print</h3>'
        + forLine(ctx)
        + '<p class="olc-for">Custom changes aren&#39;t available on Limited Edition or Heavy pieces &mdash; these are produced exactly as designed.</p>'
      );
      ov.querySelector(".olc-close").addEventListener("click", close);
      return;
    }
    var types = [
      { key: "color", t: "Color change", d: "Recolor the art - match another print, or go custom." },
      { key: "text", t: "Text + design", d: "Add a frequency, city, flight number, or note." },
      { key: "orient", t: "Diagram orientation", d: "Flip the layout North/South if you prefer." },
      { key: "version", t: "Version - White Line or Raw Metal", d: "Get this print as a white-line or raw-metal edition." }
    ];
    ov.innerHTML = shell(
      '<div class="olc-eyebrow">Make it yours</div>'
      + '<h3 class="olc-h">Customize this print</h3>'
      + forLine(ctx)
      + '<div class="olc-types">'
      + types.map(function (x) {
          return '<button type="button" class="olc-type" data-key="' + x.key + '"><span class="tw"><span class="t">' + esc(x.t) + '</span><span class="d">' + esc(x.d) + "</span></span>"
            + '<span class="p">' + priceLabel(x.key, ctx) + "</span></button>";
        }).join("")
      + "</div>"
      + '<p class="olc-note" style="margin-top:14px">' + memberNote(ctx) + "</p>"
      + '<p class="olc-note" style="margin-top:4px">We send a proof within 24 hours - we never print until you approve.</p>'
    );
    ov.querySelector(".olc-close").addEventListener("click", close);
    ov.querySelectorAll(".olc-type").forEach(function (b) {
      b.addEventListener("click", function () { renderDetails(ov, ctx, b.dataset.key, close); });
    });
  }

  function renderDetails(ov, ctx, key, close) {
    var cfg = CHANGES[key];
    var fields = "";
    // "Which artwork" - prefilled+locked on product pages, editable elsewhere.
    if (!ctx.title) {
      fields += '<div class="olc-field"><label>Which artwork is this for?</label><input class="f-art" placeholder="e.g. DCA | Washington, DC"></div>';
    }
    if (key === "color") {
      fields += '<div class="olc-field"><label>What color change would you like?</label>'
        + '<p class="hint">Easiest: name <strong>another print to match</strong> and we will match its colors. Or describe exactly what you want - the more specific, the better.</p>'
        + '<textarea class="f-detail" placeholder="e.g. Match the BOS print  /  or: navy to forest green, keep runways white"></textarea></div>';
    } else if (key === "text") {
      fields += '<div class="olc-field"><label>What text should we add, and where?</label>'
        + '<p class="hint">Radio frequency, city name, flight number, a date - anything.</p>'
        + '<textarea class="f-detail" placeholder="e.g. Add &quot;N4521C&quot; centered below the title"></textarea></div>';
    } else if (key === "version") {
      fields += '<div class="olc-field"><label>Which version would you like?</label>'
        + '<div class="olc-radios">'
        + '<label class="olc-radio sel"><input type="radio" name="ver" value="White Line" checked>White Line</label>'
        + '<label class="olc-radio"><input type="radio" name="ver" value="Raw Metal">Raw Metal</label>'
        + "</div>"
        + '<p class="hint" style="margin-top:8px">Raw is available on metal only.</p></div>'
        + '<div class="olc-field"><label>Notes (optional)</label><textarea class="f-detail" placeholder="Anything we should know? e.g. size or material."></textarea></div>';
    } else {
      fields += '<div class="olc-field"><label>Orientation</label>'
        + '<div class="olc-radios">'
        /* Ryan 2026-08-02: the keep-it-as-it-is option is gone. Someone who
           opens the orientation chooser is not asking us to leave the diagram
           alone, so it was a dead choice that only invited a no-op request.
           North/South is now pre-selected and is the only option. The input
           keeps name="ori" and value="North/South" - the product nav icons
           preselect it by exactly that selector, and submit still reads
           props["Orientation"] from it. */
        + '<label class="olc-radio sel"><input type="radio" name="ori" value="North/South" checked>North / South</label>'
        + "</div></div>"
        + '<div class="olc-field"><label>Notes (optional)</label><p class="hint">If there are multiple diagrams, tell us which one(s) to change.</p><textarea class="f-detail" placeholder="Which diagram(s)? Any other detail."></textarea></div>';
    }

    var plabel = priceLabel(key, ctx);
    ov.innerHTML = shell(
      '<button type="button" class="olc-back">&larr; back</button>'
      + '<div class="olc-eyebrow">' + plabel + (plabel === "Free" ? "" : " - one-time") + '</div>'
      + '<h3 class="olc-h">' + esc(cfg.label) + "</h3>"
      + forLine(ctx)
      + fields
      + '<p class="olc-note" style="margin:2px 0 10px">We&#39;ll email you a proof to approve &mdash; nothing prints until you say go.</p>'
      + '<button type="button" class="olc-add">Add to cart &mdash; ' + plabel + "</button>"
      + '<div class="olc-msg"></div>'
      + '<p class="olc-note">' + memberNote(ctx) + "</p>"
    );

    ov.querySelector(".olc-close").addEventListener("click", close);
    ov.querySelector(".olc-back").addEventListener("click", function () { renderChooser(ov, ctx, close); });
    ov.querySelectorAll(".olc-radio").forEach(function (lab) {
      lab.addEventListener("click", function () {
        ov.querySelectorAll(".olc-radio").forEach(function (l) { l.classList.remove("sel"); });
        lab.classList.add("sel");
      });
    });

    ov.querySelector(".olc-add").addEventListener("click", function () {
      var msg = ov.querySelector(".olc-msg");
      var artInput = ov.querySelector(".f-art");
      var artwork = ctx.title || (artInput ? artInput.value.trim() : "");
      var detail = (ov.querySelector(".f-detail") || {}).value || "";
      detail = detail.trim();
      var ori = (ov.querySelector('input[name="ori"]:checked') || {}).value || "";
      var ver = (ov.querySelector('input[name="ver"]:checked') || {}).value || "";

      if (!artwork) { msg.textContent = "Please tell us which artwork this is for."; return; }
      if ((key === "color" || key === "text") && !detail) { msg.textContent = "Please add a few details so we can proof it."; return; }

      var props = { "For artwork": artwork };
      if (key === "color") props["Color request"] = detail;
      else if (key === "text") props["Text to add"] = detail;
      else if (key === "version") { props["Version requested"] = ver; if (detail) props["Notes"] = detail; }
      else { props["Orientation"] = ori; if (detail) props["Notes"] = detail; }

      var btn = ov.querySelector(".olc-add");
      btn.disabled = true; btn.textContent = "Adding...";
      addChange(cfg.vid, props).then(function (res) {
        refreshCart(res, "update"); ov.__added = true;
        ov.querySelector(".olc-modal").innerHTML =
          '<div class="olc-done"><div class="ck">&#10003;</div><h4>Added to your cart</h4>'
          + "<p>Your " + esc(cfg.label.toLowerCase()) + " is on the order. We&#39;ll email a proof within 24 hours - nothing prints until you approve.</p></div>";
        setTimeout(close, 2200);
      }).catch(function (err) {
        btn.disabled = false; btn.textContent = "Try again";
        msg.textContent = (err && err.shopifyMsg) || "Something went wrong - please try again.";
      });
    });
  }

  // ---- "Wood, Canvas or Big Metal" flow (uses the BONUS product) ---------
  function renderMaterial(ov, ctx, close) {
    var sel = { mat: null, size: null, design: null };
    ov.innerHTML = shell(
      '<button type="button" class="olc-back">&larr; back</button>'
      + '<div class="olc-eyebrow">Priced separately</div>'
      + '<h3 class="olc-h">Wood, Canvas or Big Metal</h3>'
      + forLine(ctx)
      + (ctx.title ? "" : '<div class="olc-field"><label>Which artwork is this for?</label><input class="f-art" placeholder="e.g. DCA | Washington, DC"></div>')
      + '<div class="olc-mat-body"><p class="olc-note">Loading options&hellip;</p></div>'
      + '<div class="olc-msg"></div>'
      + '<p class="olc-note" style="margin-top:8px">We send a proof within 24 hours - we never print until you approve.</p>'
    );
    ov.querySelector(".olc-close").addEventListener("click", close);
    ov.querySelector(".olc-back").addEventListener("click", function () { close(); });
    var body = ov.querySelector(".olc-mat-body");
    var msg = ov.querySelector(".olc-msg");

    loadBonus().then(function (variants) {
      function uniq(a) { var o = {}; a.forEach(function (x) { o[x] = 1; }); return Object.keys(o); }
      function area(sz) { var m = /(\d+)\s*x\s*(\d+)/.exec(sz); return m ? m[1] * m[2] : 1e9; }
      function sizesFor(m) { return uniq(variants.filter(function (v) { return v.mat === m; }).map(function (v) { return v.size; })).sort(function (a, b) { return area(a) - area(b); }); }
      function designsFor(m, s) { return uniq(variants.filter(function (v) { return v.mat === m && v.size === s; }).map(function (v) { return v.design; })); }
      function findV() { return variants.filter(function (v) { return v.mat === sel.mat && v.size === sel.size && v.design === sel.design; })[0]; }
      function radios(name, values, current, labels) {
        return '<div class="olc-radios">' + values.map(function (val) {
          return '<label class="olc-radio' + (val === current ? " sel" : "") + '"><input type="radio" name="' + name + '" value="' + esc(val) + '"' + (val === current ? " checked" : "") + ">" + esc((labels && labels[val]) || val) + "</label>";
        }).join("") + "</div>";
      }
      function draw() {
        var html = '<div class="olc-field"><label>Material</label>' + radios("mat", BONUS.materials, sel.mat, BONUS.label) + "</div>";
        if (sel.mat) {
          html += '<div class="olc-field"><label>Size</label>' + radios("size", sizesFor(sel.mat), sel.size) + "</div>";
          if (sel.size) {
            var designs = designsFor(sel.mat, sel.size);
            if (designs.length > 1) { html += '<div class="olc-field"><label>Design</label>' + radios("design", designs, sel.design) + "</div>"; }
            else { sel.design = designs[0]; }
          }
        }
        var v = findV();
        html += '<button type="button" class="olc-add"' + (v ? "" : " disabled") + ">"
          + (v ? "Add to cart &mdash; " + money(v.price) : "Select material &amp; size") + "</button>";
        body.innerHTML = html;
        body.querySelectorAll('input[type="radio"]').forEach(function (r) {
          r.addEventListener("change", function () {
            if (r.name === "mat") { sel.mat = r.value; sel.size = null; sel.design = null; }
            else if (r.name === "size") { sel.size = r.value; sel.design = null; }
            else { sel.design = r.value; }
            draw();
          });
        });
        var addBtn = body.querySelector(".olc-add");
        if (addBtn && !addBtn.disabled) addBtn.addEventListener("click", function () {
          var artInput = ov.querySelector(".f-art");
          var artwork = ctx.title || (artInput ? artInput.value.trim() : "");
          if (!artwork) { msg.textContent = "Please tell us which artwork this is for."; return; }
          var v2 = findV();
          if (!v2) { msg.textContent = "Please choose a material and size."; return; }
          addBtn.disabled = true; addBtn.textContent = "Adding...";
          /* _art_image is the customer's own artwork. The leading underscore
             means the cart does not PRINT it as a property line (Horizon skips
             keys starting with "_"), but cart-products.liquid reads it to draw
             the thumbnail. Without it the cart shows the BONUS SKU's picture,
             which is not what they just bought. */
          var props = { "For artwork": artwork, "Material": sel.mat, "Size": sel.size, "Design": sel.design };
          if (ctx.image) props._art_image = ctx.image;
          addChange(v2.id, props).then(function (res) {
            refreshCart(res, "update"); ov.__added = true;
            ov.querySelector(".olc-modal").innerHTML =
              '<div class="olc-done"><div class="ck">&#10003;</div><h4>Added to your cart</h4>'
              + "<p>Your " + esc(sel.mat.toLowerCase()) + " print (" + esc(sel.size) + ") is on the order for <strong>" + esc(artwork) + "</strong>. We&#39;ll email a proof before printing.</p></div>";
            setTimeout(close, 2600);
          }).catch(function (err) {
            addBtn.disabled = false; addBtn.textContent = "Try again";
            msg.textContent = (err && err.shopifyMsg) || "Something went wrong - please try again.";
          });
        });
      }
      draw();
    }).catch(function () { body.innerHTML = '<p class="olc-note">Could not load material options - please try again.</p>'; });
  }

  // ---- wire up the Customize buttons -------------------------------------
  // The button is full-width via the Liquid block, so it stacks cleanly under
  // Add to Cart (best for mobile) - no DOM relocation needed.
  function wire() {
    document.addEventListener("click", function (e) {
      if (!e.target.closest) return;
      var matBtn = e.target.closest(".ol-materials-btn");
      var btn = matBtn || e.target.closest(".ol-customize-btn");
      if (!btn) return;
      e.preventDefault();
      openPopup({
        title: btn.getAttribute("data-product-title") || "",
        tags: btn.getAttribute("data-product-tags") || "",
        handle: btn.getAttribute("data-product-handle") || "",
        image: btn.getAttribute("data-product-image") || "",
        member: btn.getAttribute("data-member") || ""
      }, matBtn ? "material" : null);
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", wire);
  else wire();
})();
